import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const StyledBadge = styled.span`
  display: inline-block;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  background: ${colors.sale};
  color: ${colors.white};
  padding: ${space[1]} 10px;
  border-radius: ${space[1]};
  letter-spacing: 0.2px;

  &[data-tone='neutral'] {
    background: ${colors.lighterGrey};
    color: ${colors.fontSecondary};
    padding: 2px ${space[2]};
    border-radius: ${layout.borderRadiusLg};
    letter-spacing: normal;
  }
`;
